import z from "zod";
export const DTOCodeComponentProperty = z.object({
    name: z.string(),
    type: z.string(),
    isRequired: z.boolean(),
});
export const DTOCodeComponentStorybookFile = z.object({
    name: z.string(),
    type: z.enum(["Story", "Doc"]),
    filePath: z.string(),
});
export const DTOCodeComponentDocFile = z.object({
    filePath: z.string(),
});
export const DTOCodeComponent = z.object({
    /** Stable identifier for the code component (Prisma row id, stringified). */
    id: z.string(),
    /** Name of the component in code */
    name: z.string(),
    /** Name of the package (from package.json) from where the component was imported */
    packageName: z.string(),
    /** Name of the repository that contains this component */
    repositoryName: z.string(),
    /** JSDoc comment for this component */
    description: z.string(),
    /** File path of this component, relative to the repository root */
    filePath: z.string(),
    /** All code properties of this component */
    props: DTOCodeComponentProperty.array(),
    /** List of Storybook files that mention this component */
    storybookFiles: DTOCodeComponentStorybookFile.array(),
    /** List of doc files (markdown) that mention this component */
    docFiles: DTOCodeComponentDocFile.array(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const DTOCodeComponentResponse = z.object({
    component: DTOCodeComponent,
});
export const DTOCodeComponentListResponse = z.object({
    components: DTOCodeComponent.array(),
});
export const DTOCodeComponentDeleteResponse = z.object({
    ok: z.literal(true),
});
/** Reference to a single code component by its package and component name */
export const DTOCodeComponentReference = z.object({
    /** Name of the package (from package.json) the component is imported from */
    packageName: z.string(),
    /** Name of the component in code */
    componentName: z.string(),
});
/** Request body for fetching AI-generated markdown for a batch of code components */
export const DTOCodeComponentMarkdownQuery = z.object({
    /** Components to fetch markdown for */
    components: DTOCodeComponentReference.array().min(1).max(20),
});
/** AI-generated markdown detail for a single code component */
export const DTOCodeComponentMarkdown = z.object({
    /** Name of the component in code */
    name: z.string(),
    /** Stable key identifying the component within its package */
    componentKey: z.string(),
    /** Name of the package (from package.json) the component is imported from */
    packageName: z.string(),
    /** File path of the component, relative to the repository root */
    componentPath: z.string(),
    /** AI-generated markdown describing the component's API and usage */
    markdown: z.string(),
});
export const DTOCodeComponentMarkdownResponse = z.object({
    /** Components for which markdown was found */
    components: DTOCodeComponentMarkdown.array(),
});
//
// Write
//
export const DTOCodeComponentCreateInput = DTOCodeComponent.pick({
    name: true,
    packageName: true,
    repositoryName: true,
    description: true,
    props: true,
    filePath: true,
    docFiles: true,
    storybookFiles: true,
}).extend({
    componentDocs: z.string().optional(),
});
export const DTOCodeComponentUpdateInput = DTOCodeComponent.pick({
    description: true,
    props: true,
    filePath: true,
    docFiles: true,
    storybookFiles: true,
})
    .partial()
    .extend({
    componentDocs: z.string().optional(),
});
